import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_75ed9af7 from 'nuxt_plugin_bootstrapvue_75ed9af7' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_portalvue_7166b6ea from 'nuxt_plugin_portalvue_7166b6ea' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_dayjsplugin_228d39d6 from 'nuxt_plugin_dayjsplugin_228d39d6' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_e734db1a from 'nuxt_plugin_pluginutils_e734db1a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_81696204 from 'nuxt_plugin_pluginrouting_81696204' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_bffba59e from 'nuxt_plugin_pluginmain_bffba59e' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vue2editor_316d0a10 from 'nuxt_plugin_vue2editor_316d0a10' // Source: ./vue2-editor.js (mode: 'client')
import nuxt_plugin_deviceplugin_62ec5453 from 'nuxt_plugin_deviceplugin_62ec5453' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_axios_adbbf670 from 'nuxt_plugin_axios_adbbf670' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_46491470 from 'nuxt_plugin_cookieuniversalnuxt_46491470' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_libplugin658e4877_37c3ac08 from 'nuxt_plugin_libplugin658e4877_37c3ac08' // Source: ./lib.plugin.658e4877.js (mode: 'all')
import nuxt_plugin_socket_412a8e67 from 'nuxt_plugin_socket_412a8e67' // Source: ../../plugins/socket (mode: 'client')
import nuxt_plugin_chart_223dba6a from 'nuxt_plugin_chart_223dba6a' // Source: ../../plugins/chart (mode: 'client')
import nuxt_plugin_downloadfile_1bb80ba6 from 'nuxt_plugin_downloadfile_1bb80ba6' // Source: ../../plugins/download-file (mode: 'client')
import nuxt_plugin_bootstrapvue_8290879a from 'nuxt_plugin_bootstrapvue_8290879a' // Source: ../../plugins/bootstrap-vue (mode: 'client')
import nuxt_plugin_clickoutside_33371f89 from 'nuxt_plugin_clickoutside_33371f89' // Source: ../../plugins/directives/click-outside (mode: 'client')
import nuxt_plugin_addtab_1923e3f5 from 'nuxt_plugin_addtab_1923e3f5' // Source: ../../plugins/add-tab (mode: 'all')
import nuxt_plugin_modals_36edca5a from 'nuxt_plugin_modals_36edca5a' // Source: ../../plugins/modals (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../../plugins/i18n (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../../plugins/axios (mode: 'all')
import nuxt_plugin_user_925ef082 from 'nuxt_plugin_user_925ef082' // Source: ../../plugins/user (mode: 'all')
import nuxt_plugin_translateoptions_2ab39dab from 'nuxt_plugin_translateoptions_2ab39dab' // Source: ../../plugins/translate-options (mode: 'all')
import nuxt_plugin_vuelidate_0f19c03d from 'nuxt_plugin_vuelidate_0f19c03d' // Source: ../../plugins/vuelidate (mode: 'all')
import nuxt_plugin_globalcomponents_54ec6fe8 from 'nuxt_plugin_globalcomponents_54ec6fe8' // Source: ../../plugins/global-components (mode: 'all')
import nuxt_plugin_formatdate_2f15d93c from 'nuxt_plugin_formatdate_2f15d93c' // Source: ../../plugins/filters/format-date (mode: 'all')
import nuxt_plugin_yearonly_27b8b2b4 from 'nuxt_plugin_yearonly_27b8b2b4' // Source: ../../plugins/filters/year-only (mode: 'all')
import nuxt_plugin_startcase_3b285943 from 'nuxt_plugin_startcase_3b285943' // Source: ../../plugins/filters/start-case (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Rezume","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Montserrat:ital,wght@0,300;0,400;0,500;0,600;1,400;1,500;1,600"}],"script":[{"src":"\u002Fvuexy\u002Fvendors\u002Fjs\u002Fvendors.min.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_75ed9af7 === 'function') {
    await nuxt_plugin_bootstrapvue_75ed9af7(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_7166b6ea === 'function') {
    await nuxt_plugin_portalvue_7166b6ea(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_228d39d6 === 'function') {
    await nuxt_plugin_dayjsplugin_228d39d6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_e734db1a === 'function') {
    await nuxt_plugin_pluginutils_e734db1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_81696204 === 'function') {
    await nuxt_plugin_pluginrouting_81696204(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_bffba59e === 'function') {
    await nuxt_plugin_pluginmain_bffba59e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2editor_316d0a10 === 'function') {
    await nuxt_plugin_vue2editor_316d0a10(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_62ec5453 === 'function') {
    await nuxt_plugin_deviceplugin_62ec5453(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_adbbf670 === 'function') {
    await nuxt_plugin_axios_adbbf670(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_46491470 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_46491470(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin658e4877_37c3ac08 === 'function') {
    await nuxt_plugin_libplugin658e4877_37c3ac08(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socket_412a8e67 === 'function') {
    await nuxt_plugin_socket_412a8e67(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chart_223dba6a === 'function') {
    await nuxt_plugin_chart_223dba6a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_downloadfile_1bb80ba6 === 'function') {
    await nuxt_plugin_downloadfile_1bb80ba6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bootstrapvue_8290879a === 'function') {
    await nuxt_plugin_bootstrapvue_8290879a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickoutside_33371f89 === 'function') {
    await nuxt_plugin_clickoutside_33371f89(app.context, inject)
  }

  if (typeof nuxt_plugin_addtab_1923e3f5 === 'function') {
    await nuxt_plugin_addtab_1923e3f5(app.context, inject)
  }

  if (typeof nuxt_plugin_modals_36edca5a === 'function') {
    await nuxt_plugin_modals_36edca5a(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_user_925ef082 === 'function') {
    await nuxt_plugin_user_925ef082(app.context, inject)
  }

  if (typeof nuxt_plugin_translateoptions_2ab39dab === 'function') {
    await nuxt_plugin_translateoptions_2ab39dab(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_0f19c03d === 'function') {
    await nuxt_plugin_vuelidate_0f19c03d(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_54ec6fe8 === 'function') {
    await nuxt_plugin_globalcomponents_54ec6fe8(app.context, inject)
  }

  if (typeof nuxt_plugin_formatdate_2f15d93c === 'function') {
    await nuxt_plugin_formatdate_2f15d93c(app.context, inject)
  }

  if (typeof nuxt_plugin_yearonly_27b8b2b4 === 'function') {
    await nuxt_plugin_yearonly_27b8b2b4(app.context, inject)
  }

  if (typeof nuxt_plugin_startcase_3b285943 === 'function') {
    await nuxt_plugin_startcase_3b285943(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
